import { createSelector } from 'reselect';

const userLogsData = (state) => state.userLogsData;

export const selectUserLogsFilterData = () =>
  createSelector([userLogsData], (state) => state.filter);
